import { render, staticRenderFns } from "./Operadores.vue?vue&type=template&id=b4ff8696&scoped=true"
import script from "./Operadores.vue?vue&type=script&lang=js"
export * from "./Operadores.vue?vue&type=script&lang=js"
import style0 from "./Operadores.vue?vue&type=style&index=0&id=b4ff8696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ff8696",
  null
  
)

export default component.exports